import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import {FormattedMessage} from "react-intl";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import {PackageContext} from "./context/PackageContext";
import Breadcrumb, {BreadcrumbGroup} from "@amzn/meridian/breadcrumb";
import Box from "@amzn/meridian/box";
import Column from "@amzn/meridian/column";
import {useState} from "react"
import Pagination from "@amzn/meridian/pagination";
import {CSVLink} from 'react-csv'

const PackageList = (props) => {

    const {viewModel, dispatch} = useContext(PackageContext);
    const [currentPage, setCurrentPage] = useState(1);

    const filter = {
        "Cycle": props.packageList.filter ? props.packageList.filter.Cycle ? props.packageList.filter.Cycle : [] : [],
        "EAD": props.packageList.filter ? props.packageList.filter.EAD ? props.packageList.filter.EAD : [] : [],
        "OtherAttributes": props.packageList.filter ? props.packageList.filter.OtherAttributes ? props.packageList.filter.OtherAttributes : [] : [],
        "Cluster": props.packageList.filter ? props.packageList.filter.Cluster ? props.packageList.filter.Cluster : [] : [],
        "PackageSize": props.packageList.filter ? props.packageList.filter.PackageSize ? props.packageList.filter.PackageSize : [] : [],
    }
    useEffect(() => {
        dispatch({type: 'LOAD_VIEW', data:{dispatcher: dispatch, lineHaulId: props.packageList.lineHaulId, containerId: props.packageList.containerId, filters: filter,
                packageState: props.packageList.packageState ? props.packageList.packageState : "ALL"}});
        return () => dispatch({ type: 'UNLOAD_VIEW'});
    }, []);

    const getHistory = () => {
        return props.packageList.path && props.packageList.path === "Induct" ?
            (<Breadcrumb href="#induct">
                <FormattedMessage id="linduct.induct" defaultMessage="Induct"/>
            </Breadcrumb>) : (<Breadcrumb href="#receive">
                <FormattedMessage id="linehaul_detail.receive" defaultMessage="Receive"/>
            </Breadcrumb>)
    }

    const onSort = (sortDetails) => {
        dispatch({
            type: 'SORT_DATA',
            data: {column: sortDetails.sortColumn, direction: sortDetails.sortDirection}
        })
    }

    const sortedPackageList = [...viewModel.packageList];
    sortedPackageList && sortedPackageList.sort((a, b) => {
        if (a[viewModel.sortPref.column] < b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? -1 : 1
        }
        if (a[viewModel.sortPref.column] > b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? 1 : -1
        }
        return 0
    })

    return (
        <Column>
            <Row widths={["grid-12"]} alignmentVertical="top" spacingInset="large none none large">
                <Box>
                    <BreadcrumbGroup>
                        {getHistory()}
                        <Breadcrumb>
                            <FormattedMessage id="package.package_list" defaultMessage="Package List"/>
                        </Breadcrumb>
                    </BreadcrumbGroup>
                </Box>
            </Row>
            <Row
                alignmentVertical="top"
                alignmentHorizontal="right"
                spacingInset="none large none large">
                <CSVLink data={sortedPackageList}
                         style={{textDecoration: 'none', fontWeight: 'bold', color: '#008B8B'}}
                         filename='package_details.csv'>
                    <FormattedMessage id="package.download" defaultMessage="Download"/>
                </CSVLink>
            </Row>
            <Row widths={["grid-12"]} alignmentVertical="top" spacingInset="none none medium large">
                <Heading level={1} alignment="left">
                    <FormattedMessage id="package.package_summary" defaultMessage="Package Summary"/>
                </Heading>
            </Row>
            <Row widths={["grid-11"]} alignmentVertical="top" className="enable-scroll-x" spacingInset="none none none large">
                <Table headerRows={1} spacing="small"
                       sortColumn={viewModel.sortPref.column}
                       sortDirection={viewModel.sortPref.direction}
                       onSort={onSort}>
                    <TableRow>
                        <TableCell sortColumn="trackingId">
                            <FormattedMessage id="package.tracking_id" defaultMessage="Tracking ID"/>
                        </TableCell>
                        <TableCell sortColumn="cycle">
                            <FormattedMessage id="package.cycle" defaultMessage="Cycle"/>
                        </TableCell>
                        <TableCell sortColumn="state">
                            <FormattedMessage id="package.package_state" defaultMessage="State"/>
                        </TableCell>
                        <TableCell sortColumn="reason">
                            <FormattedMessage id="package.package_reason" defaultMessage="Reason"/>
                        </TableCell>
                        <TableCell sortColumn="cluster">
                            <FormattedMessage id="package.cluster" defaultMessage="Cluster"/>
                        </TableCell>
                        <TableCell width={"100px"} sortColumn="sortZone">
                            <FormattedMessage id="package.sort_zone" defaultMessage="Sort Zone"/>
                        </TableCell>
                        <TableCell width={"140px"} sortColumn="minInState">
                            <FormattedMessage id="package.minutes_in_state" defaultMessage="Minutes in State"/>
                        </TableCell>
                        <TableCell width={"100px"} sortColumn="lastScanDateTime">
                            <FormattedMessage id="package.last_scan_date_time" defaultMessage="Last Scan"/>
                        </TableCell>
                        <TableCell sortColumn="location">
                            <FormattedMessage id="package.location" defaultMessage="Location"/>
                        </TableCell>
                        <TableCell sortColumn="ead">
                            <FormattedMessage id="package.EAD" defaultMessage="EAD"/>
                        </TableCell>
                        <TableCell sortColumn="size">
                            <FormattedMessage id="package.size" defaultMessage="Size"/>
                        </TableCell>
                    </TableRow>
                    {sortedPackageList.slice((currentPage-1) * 25, currentPage * 25).map(item => (
                        <TableRow>
                            <TableCell>{item.trackingId}</TableCell>
                            <TableCell>{item.cycle}</TableCell>
                            <TableCell>{item.state}</TableCell>
                            <TableCell>{item.reason}</TableCell>
                            <TableCell>{item.cluster}</TableCell>
                            <TableCell>{item.sortZone}</TableCell>
                            <TableCell>{item.minInState}</TableCell>
                            <TableCell width={"150px"}>{item.lastScanDateTime}</TableCell>
                            <TableCell>{item.location}</TableCell>
                            <TableCell width={"150px"}>{item.ead}</TableCell>
                            <TableCell>{item.size}</TableCell>
                        </TableRow>
                    ))}
                </Table>
            </Row>
            <Row alignmentVertical="top" alignmentHorizontal="center">
                <Pagination
                    numberOfPages={Math.ceil(sortedPackageList.length / 25)}
                    onChange={setCurrentPage}
                    currentPage={currentPage}
                />
            </Row>
        </Column>
    );
}

export default PackageList


// WEBPACK FOOTER //
// ./src/components/package/PackageList.js